import React, { useState } from 'react';
import { signIn } from './api';

export default function SignIn({ onDone }) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const go = async () => {
    setBusy(true); setError('');
    try { onDone(await signIn()); }
    catch (e) {
      // Closing the popup isn't an error worth showing.
      if (e.code === 'auth/popup-closed-by-user' || e.code === 'auth/cancelled-popup-request') { setBusy(false); return; }
      setError(e.status === 403 ? 'this google account is not on the list' : e.message || 'sign-in failed');
      setBusy(false);
    }
  };
  return (
    <div className="df-signin">
      <p className="df-muted">private. one sign-in per day.</p>
      <button className="df-btn" onClick={go} disabled={busy}>{busy ? 'signing in…' : 'sign in with google'}</button>
      {error && <p className="df-error">{error}</p>}
    </div>
  );
}
